import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './authContext';

interface ProtectedRouteProps {
  children: React.JSX.Element;
  /** Restrict to admins. A signed-in client is bounced like a stranger. */
  requireAdmin?: boolean;
}

/**
 * Route guard. Anyone who is not allowed through lands on /signin, with the
 * page they wanted remembered so the sign-in form can send them back there.
 *
 * This only hides the screen — it is not a security boundary. The API still
 * has to check the token on every admin request, because nothing stops someone
 * editing localStorage to say `role: "admin"`.
 */
const ProtectedRoute = ({ children, requireAdmin = false }: ProtectedRouteProps) => {
  const { isLoggedIn, isAdmin } = useAuth();
  const location = useLocation();

  if (!isLoggedIn || (requireAdmin && !isAdmin)) {
    return <Navigate to="/signin" replace state={{ from: location.pathname }} />;
  }

  return children;
};

export default ProtectedRoute;
